import { useQuery } from '@tanstack/react-query';

import { useHookInjection } from 'domain/hooks';
import { TournamentLocationsRepository, ITournamentLocationsRepository } from 'domain/repositories/ITournamentLocationsRepository';

export const TournamentLocationsKey = 'TournamentLocations';

export const useCaseGetTournamentLocations = () => {
  const { fetchTournamentLocations } = useHookInjection<ITournamentLocationsRepository>(
    TournamentLocationsRepository,
  );

  const { data, error, isLoading } = useQuery({
    retry: 3,
    queryKey: [TournamentLocationsKey],
    queryFn: () => fetchTournamentLocations(),
  });

  return { data: data ?? [], error, isLoading };
};
